const COLUMNS_GROUPS = [
  {
    id: "date",
    label: "DATE",
    widget: "text",
    width: 150
  },
  {
    id: "branch",
    label: "BRANCH",
    widget: "text",
    width: 180
  },
  {
    id: "paymentnumber",
    label: "PAYMENT #",
    widget: "text",
    width: 180
  },
  {
    id: "type",
    label: "TYPE",
    widget: "text",
    width: 220
  },
  {
    id: "referencenumber",
    label: "REFERENCE NUMBER",
    widget: "text",
    width: 200
  },
  {
    id: "customername",
    label: "CUSTOMER NAME",
    widget: "text",
    width: 250
  },
  {
    id: "invoice",
    label: "INVOICE#",
    widget: "text",
    width: 150
  },
  {
    id: "mode",
    label: "MODE",
    widget: "text",
    width: 150
  },
  {
    id: "amount",
    label: "AMOUNT",
    widget: "number",
    width: 150
  },
  {
    id: "unusedamount",
    label: "UNUSED AMOUNT",
    widget: "number",
    width: 150
  }
];

const ROW_DATA = [
  {
    date: "11 Dec 2025",
    branch: "Head Office",
    paymentnumber: "payment1",
    type: "Invoice Payment",
    referencenumber: "",
    customername: "John Smith Customer",
    invoice: "Invoice2",
    mode: "Cash",
    amount: 10,
    unusedamount: 0
  },
  {
    date: "11 Dec 2025",
    branch: "Head Office",
    paymentnumber: "payment2",
    type: "Retainer Payment",
    referencenumber: "",
    customername: "John Smith Customer",
    invoice: "",
    mode: "Cash",
    amount: 27074,
    unusedamount: 0
  },
  {
    date: "11 Dec 2025",
    branch: "Head Office",
    paymentnumber: "payment3",
    type: "Invoice Payment",
    referencenumber: "123456789",
    customername: "Emily Johnson Customer",
    invoice: "Invoice11",
    mode: "Stripe",
    amount: 10,
    unusedamount: 0
  }];

export {COLUMNS_GROUPS,ROW_DATA};